var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Component Sketches")]),_c('selectComponent',{on:{"selectedComponentFunc":_vm.selectedComponentFunc}}),_c('v-divider'),(_vm.selectedComponent)?_c('div',[_c('oneOption',{key:_vm.selectedComponent.id,attrs:{"oprionID":_vm.selectedComponent.id,"relativePath":`PCB/components/fields/ID1`}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }